<template>

<div>

    <modal-form
        :active-voucher="activeVoucher"
        :customer="customer"
        @refresh="reFetch()">
    </modal-form>

<!--    <modal-punch :active-card="activeCard"-->
<!--           :customer="customer"-->
<!--           :inactive-from-period="inactiveFromPeriod">-->
<!--    </modal-punch>-->

    <div class="panel panel-clinic">

        <div class="panel-heading" href="#customer_vouchers" data-toggle="collapse">

            <div class="arrow-down"></div>

            <h2 class="panel-title">Kuponger</h2>

        </div>

        <div id="customer_vouchers" class="panel-collapse collapse">

            <div class="panel-body">

                <a class="btn btn-default btn-sm pull-right" data-target="#modal_voucher_form" data-toggle="modal" v-on:click="openModal('new')">
                	<i class="fa fa-file" style="margin-right: 4px;" aria-hidden="true"></i> Ny kupong
                </a>

<!--                <a class="btn btn-default btn-sm pull-right">-->
<!--                	<i class="fa fa-file" aria-hidden="true"></i> Registrera behandling-->
<!--                </a>-->

                <h3>Kuponger</h3>

                <div class="panel panel-default">

                    <div class="panel-heading">
                        <div class="row">
                            <div class="col-lg-7 col-md-8 hidden-sm col-xs-19">Skapad</div>
                            <div class="col-lg-7 col-md-8 hidden-sm hidden-xs">Giltig till</div>
                            <div class="col-lg-8 col-md-10 hidden-sm hidden-xs">Förs. kanal</div>
                            <div class="col-lg-5 hidden-md hidden-sm hidden-xs">Konto</div>
                            <div class="col-lg-4 col-md-6 col-xs-19">Saldo</div>
                            <div class="col-lg-4 col-md-6 hidden-sm hidden-xs">Nyttjat</div>
                            <div class="col-lg-11 col-md-4 hidden-sm hidden-xs">Kvar</div>
                        </div>
                    </div>

                    <div class="list-group">

                        <li class="list-group-item" v-for="voucher in vouchers">

                            <div class="row">

                                <div class="col-lg-7 col-md-8 hidden-sm col-xs-19">{{ voucher.created_at.substring(0, 10) }}</div>
                                <div class="col-lg-7 col-md-8 hidden-sm hidden-xs">{{ voucher.valid_to.substring(0, 10) }}</div>
                                <div class="col-lg-8 col-md-10 hidden-sm hidden-xs">{{ voucher.affiliate.name }}</div>
                                <div class="col-lg-5 hidden-md hidden-sm hidden-xs">{{ voucher.account.name }}</div>
                                <div class="col-lg-4 col-md-6 col-xs-19">{{ voucher.value_total }} kr</div>
                                <div class="col-lg-4 col-md-6 hidden-sm hidden-xs">{{ voucher.value_used }} kr</div>
                                <div class="col-lg-11 col-md-6 hidden-sm hidden-xs">{{ voucher.value_total - voucher.value_used  }} kr</div>

                                <div class="col-lg-4 col-md-6 col-xs-11">

                                    <div class="btn-group">

                                        <button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Hantera <span class="caret"></span>
                                        </button>

                                        <ul class="dropdown-menu">

                                            <li v-if="voucher.value_used === 0">
                                                <a data-target="#modal_voucher_form" data-toggle="modal" v-on:click="openModal(voucher)">Ändra</a>
                                            </li>

                                            <li role="separator" class="divider" v-if="voucher.value_used === 0"></li>

                                            <li>
                                                <a @click="notify(voucher.id, 'sms')" v-if="customer.phone">
                                                    Skicka SMS
                                                </a>
                                                <a v-else style="text-decoration: line-through">
                                                    Skicka SMS
                                                </a>
                                            </li>

                                            <li>
                                                <a @click="notify(voucher.id, 'mail')" v-if="customer.email">
                                                    Skicka e-post
                                                </a>
                                                <a v-else style="text-decoration: line-through">
                                                    Skicka e-post
                                                </a>
                                            </li>

                                            <li role="separator" class="divider" v-if="voucher.value_used === 0"></li>

                                            <li>
                                                <a @click="triggerDelete(voucher.id)" v-if="voucher.value_used === 0">Ta bort</a>
                                            </li>

                                        </ul>

                                    </div>

                                </div>

                            </div>

                        </li>

                    </div>


                    <div style="margin-top: 24px;">Totalt återstående saldo:  <span style="font-weight: 600;">{{ value_remaining }} kr</span></div>

                </div>

            </div>

        </div>

    </div>

</div>

</template>

<script>

import deleter from '../../shared/mixins/deleter'
import fetcher from '../../shared/mixins/fetcher'

import modalForm from './voucher.modalForm.vue'

export default {

    mixins: [
        deleter,
        fetcher
    ],

    components: {
        modalForm
    },

    props: {
        customer: {},
        inactiveFromPeriod: {}
    },

    data () {
        return {
            activeVoucher: null,
            vouchers: [],

            fetcher: {
                autoFill: [
                    'vouchers'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/customers/' + this.customer.id + '/vouchers'
        },
        deleterUrl () {
            return '/customers/' + this.customer.id + '/vouchers'
        },

        value_remaining () {
            let value = 0
            this.vouchers.forEach(v => {
                if (moment().isBefore(moment(v.valid_to))) {
                    value += v.value_total - v.value_used
                }
            })
            return value
        }
    },

    methods: {

        reFetch () {
            this.fetcherFetch()
            bus.$emit('log-reload')
        },

        triggerDelete (voucher_id) {
            if (!confirm('Är du säker')) {
                return
            }
            this.deleterDelete(voucher_id)
        },

        deleterSuccess (data) {
            bus.$emit(
                'notify',
                'Kupongen har tagits bort.'
            )
            this.reFetch()
        },

        openModal (voucher) {
            this.activeVoucher = voucher
        },

        notify (voucher_id, type) {
            console.log('notify')

            this.$http.post('/customers/' + this.customer.id + '/vouchers/' + voucher_id + '/notify', { type: type }).then((response) => {
                console.log(response.body)

                if (type == 'sms') {
                    bus.$emit('notify', 'Skickade sms till kund.')
                }
                if (type == 'mail') {
                    bus.$emit('notify', 'Skickade e-post till kund.')
                }

                bus.$emit('log-reload')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        }

    }

}
</script>
